import $store from '@/store'

window.getProfileObj = () => {
  const { me, info } = $store.state.auth
  const { organization } = $store.state.myfinbiz
  
  me.id = info.userId
  
  return {
    me,
    organization
  }
}
